<div
  *ngIf="(showNamedSchedules$ | async) === false"
  class="desc-container"
  class="desc"
  ngClass="{ 'desc-only': !schedule.hasSubscription }"
  title="schedule"
  data-test="schedule-list-item"
>
  {{ schedule | scheduleSummary }}
</div>
<div
  *ngIf="showNamedSchedules$ | async"
  class="schedule-name"
  ngClass="{ 'desc-only': !schedule.hasSubscription }"
  title="schedule"
  data-test="schedule-list-name"
>
  {{ schedule.name }}
</div>
<div *ngIf="showNamedSchedules$ | async" class="desc-container">
  <capra-icon icon="icon-calendar"></capra-icon>
  <div class="metadata-row-text" data-test="schedule-list-item">{{ schedule | scheduleSummary }}</div>
  <capra-icon
    *ngIf="!schedule.validInterval && (adminManagedScheduleIntervals$ | async)"
    icon="icon-warning"
    class="schedule-warning-icon"
    capraTooltip
    tooltipContent="
      This schedule refreshes more frequently than is allowed by your Workspace. Edit the schedule to select a new cadence.
    "
    tooltipSize="mini"
    tooltipPlacement="right"
  >
  </capra-icon>
</div>

<div class="metadata-row" *ngIf="reportType === 'Report'" data-test="metadata-row">
  <ng-container *ngIf="!schedule.hasSubscription && !schedule.hasSlackSubscription">
    <capra-icon class="align-md-icon refresh" icon="icon-data-refresh"></capra-icon>
    <span class="metadata-row-text" data-test="refresh-only">Refresh only</span>
  </ng-container>
  <ng-container *ngIf="schedule.hasSubscription && !schedule.hasSlackSubscription">
    <capra-icon class="align-md-icon email" icon="icon-email"></capra-icon>
    <span class="metadata-row-text" data-test="email-delivery">Email delivery</span>
    <capra-icon class="align-md-icon add-margin" icon="icon-avatar"></capra-icon>
    <span class="metadata-row-text gray" data-test="subscribers-count"
      >{{ schedule.subscriberCount }} {{ schedule.subscriberCount === 1 ? 'subscriber' : 'subscribers' }}</span
    >
  </ng-container>
  <ng-container *ngIf="schedule.hasSlackSubscription">
    <capra-icon class="align-md-icon" icon="illo-mini-slack"></capra-icon>
    <span class="metadata-row-text" data-test="slack-delivery">Slack delivery</span>
    <span
      class="metadata-row-text gray"
      *ngIf="schedule.subscription?.slackSubscription?.channelType === 'public'"
      data-test="slack-channel"
      >#{{ schedule.subscription?.slackSubscription?.channel }}</span
    >
    <ng-container *ngIf="schedule.subscription?.slackSubscription?.channelType === 'private'">
      <capra-icon class="align-md-icon add-margin" icon="icon-lock"></capra-icon>
      <span class="metadata-row-text gray" data-test="private-channel">Private channel</span>
    </ng-container></ng-container
  >
</div>
